/**
 * Ítem de navegación lateral gobernado por permisos del backend.
 */
export interface NavItemDefinition {
  codigo: string;
  label: string;
  route: string;
  icon: string;
  exact?: boolean;
  subtle?: boolean;
  section?: string;
}

/** Ruta canónica del panel de control. */
export const DASHBOARD_ROUTE = '/dashboard';

/** Catálogo de menús alineado con seeds de `mst_permiso` en backend. */
export const NAV_ITEMS: NavItemDefinition[] = [
  {
    codigo: 'menu.dashboard',
    label: 'Panel de control',
    route: DASHBOARD_ROUTE,
    icon: 'layout-dashboard',
    section: 'Flujo',
    exact: true,
  },
  {
    codigo: 'menu.cargar-ingresos',
    label: 'Carga de Depósitos',
    route: '/cargar-ingresos',
    icon: 'inbox',
    section: 'Flujo',
  },
  // {
  //   codigo: 'menu.mockup',
  //   label: 'Carga de Depósitos mockup',
  //   route: '/cargar-ingresos-mockup',
  //   icon: 'file-text',
  //   section: 'Flujo',
  //   subtle: true,
  // },
  {
    codigo: 'menu.procesamiento',
    label: 'Procesamiento',
    route: '/procesamiento',
    icon: 'cpu',
    section: 'Flujo',
    exact: true,
  },
  {
    codigo: 'menu.confirmacionPago',
    label: 'Confirmación de pago',
    route: '/confirmacion-pago',
    icon: 'git-compare',
    section: 'Flujo',
    exact: true,
  },
  {
    codigo: 'menu.matriz',
    label: 'Matriz',
    route: '/matriz-recaudacion',
    icon: 'hash',
    section: 'Flujo',
    exact: true,
  },
  {
    codigo: 'menu.reportes-trazabilidad',
    label: 'Logs del sistema',
    route: '/reportes/trazabilidad-usuarios',
    icon: 'history',
    section: 'Reportes',
    exact: true,
  },
  {
    codigo: 'menu.motor-reglas-reglas',
    label: 'Reglas de recaudadores',
    route: '/motor-reglas/reglas-recaudadores',
    icon: 'file-text',
    section: 'Motor reglas',
    exact: true,
  },
  {
    codigo: 'menu.motor-reglas-errores',
    label: 'Validaciones',
    route: '/motor-reglas/errores-archivos',
    icon: 'alert-triangle',
    section: 'Motor reglas',
    exact: true,
    subtle: true,
  },
  {
    codigo: 'menu.configuracion-mantenedores',
    label: 'Configuración',
    route: '/colmena/configuracion',
    icon: 'settings-2',
    section: 'Mantenedores',
    exact: true,
  },
  // Ocultos del menú (rutas siguen disponibles por URL directa):
  // {
  //   codigo: 'menu.configuracion-recaudador',
  //   label: 'Configuración de recaudador',
  //   route: '/configuracion-recaudador',
  //   icon: 'table-2',
  //   section: 'Mantenedores',
  //   exact: true,
  // },
  // {
  //   codigo: 'menu.configuracion-layout-archivos',
  //   label: 'Layout de archivos y mapeo',
  //   route: '/configuracion-layout-archivos',
  //   icon: 'file-text',
  //   section: 'Mantenedores',
  //   exact: true,
  // },
  // {
  //   codigo: 'menu.configuracion-recaudador-mockup',
  //   label: 'Configuración de recaudador mockup',
  //   route: '/configuracion-recaudador-mockup',
  //   icon: 'file-type-2',
  //   section: 'Mantenedores',
  //   exact: true,
  //   subtle: true,
  // },
];
